import React from "react";
import { graphql } from "gatsby";
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon";
import BlockRenderer from "../components/structured-text/block-renderer";
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon";
import ProductContent from "../components/product/content";
import ProductRecipes from "../components/product/recipes";
import ProductRelated from "../components/product/related";
import ProductCta from "../components/product/cta";

const GreenwheatProduct = ({ pageContext, data }) => {

  let seoTags = data?.datoCmsGreenwheatProduct?.seoMetaTags

  const tags = seoTags.tags.map(tag => {
    if (tag.tagName === 'title') {
      tag.content = `${data?.datoCmsGreenwheatProduct?.title} Bulk Online | Edlyn Foods`;
    }
    if (tag.tagName === 'meta') {
      if (tag.attributes.property === 'og:title' || tag.attributes.name === 'twitter:title') {
        tag.attributes.content = `${data?.datoCmsGreenwheatProduct?.title} Bulk Online | Edlyn Foods`;
      }
      if (tag.attributes.property === 'og:description' || tag.attributes.name === 'twitter:description') {
        tag.attributes.content = `Bulk order ${data?.datoCmsGreenwheatProduct?.title}. Edlyn Foods supports the food service industry.`;
      }
      if (tag.attributes.name === 'description') {
        tag.attributes.content = `Bulk order ${data?.datoCmsGreenwheatProduct?.title}. Edlyn Foods supports the food service industry.`;
      }
    }
    return tag;
  });

  let updatedSeoMetaTags = { tags: tags }

  return (
    <>
      <DraftDebug publishedAt={data?.datoCmsGreenwheatProduct?.meta?.publishedAt} />
      <HelmetDatoCms seo={updatedSeoMetaTags}>
        <body className={`product-template product-template--${data?.datoCmsGreenwheatProduct?.slug === 'index' ? 'home' : 'greenwheat'}`} />
      </HelmetDatoCms>
      <ProductContent {...data?.datoCmsGreenwheatProduct} form={data?.productForm} />
      <BlockRenderer data={data?.datoCmsGreenwheatProduct?.blocks} brand={`greenwheat`} />
      <ProductRecipes brand={`greenwheat`} originalId={data?.datoCmsGreenwheatProduct.originalId} />
      <ProductRelated related={data?.datoCmsGreenwheatProduct?.related} brand={`greenwheat`} />
      <ProductCta cta={data?.productCta} />
    </>
  )
}

export const query = graphql`
  query GreenwheatProductTemplate ($originalId: String!) {
    datoCmsGreenwheatProduct(originalId: { eq: $originalId }) {
      seoMetaTags {
        tags
      }
      originalId
      jsonLd
      meta {
        publishedAt
      }
      title
      brand
      permalink
      gallery {
        ...InternalAssetProps
      }
      sku
      size
      availableIn {
      label
      url {
        ... on DatoCmsEdlynProduct {
          id
          title
          permalink
        }
        ... on DatoCmsBoneProduct {
          id
          title
          permalink
        }
        ... on DatoCmsWoodsProduct {
          id
          title
          permalink
        }
        ... on DatoCmsGreenwheatProduct {
          id
          title
          permalink
        }
      }
    }
      richContent {
        value
      }
      ingredients {
        value
      }
      nutritionalInformation {
        label
        value
      }
      tableColumnTitleOne
      tableColumnTitleTwo
      nutritionalTable {
        label
        serveValue
        perHundredValue
      }
      allergens
      directionsStorage {
        label
        value
        richValue {
          value
        }
      }
      instructionalVideo {
        ...ExternalAssetProps
      }
      freeSample
      related {
        title
        brand
        slug
        permalink
        header
        size
        gallery {
          ...InternalAssetProps
        }
      }
      blocks {
        __typename
        ...ProductCtaProps
      }
    }
    productForm: datoCmsForm(title: {eq: "Product Enquiry"}) {
      ...FormProps
    }
      productCta: datoCmsSingleProductCta(brand: {eq: "greenwheat"}) {
    brand
    buttons {
      ...LinkWithTitleProps
    }
    title
    image {
      ...InternalAssetProps
    }
  }
  }
`
export default GreenwheatProduct
